
import { Component, Vue } from 'vue-property-decorator';
import LegalLayout, { ITocItem } from './components/LegalLayout.vue';

@Component({
  components: {
    LegalLayout,
  },
})
export default class PrivacyPolicy extends Vue {
  toc: ITocItem[] = [
    { id: 'introduction', title: 'Introduction' },
    { id: 'consent', title: 'Consent' },
    { id: 'information-we-collect', title: 'Information we collect' },
    { id: 'how-we-use-information', title: 'How we use your information' },
    { id: 'log-files', title: 'Log Files' },
    { id: 'cookies', title: 'Cookies and Web Beacons' },
    { id: 'advertising-partners', title: 'Advertising Partners' },
    { id: 'third-party-policies', title: 'Third Party Policies' },
    { id: 'ccpa', title: 'CCPA Privacy Rights' },
    { id: 'gdpr', title: 'GDPR Data Protection Rights' },
    { id: 'childrens-information', title: "Children's Information" },
  ];
}
